import { TransferInitiationAssetWebDto } from '../../../api/types'

export type OtherSecuritiesErrors = {
  [key in keyof TransferInitiationAssetWebDto]?: string
}

export enum PositionEnum {
  Short = 'Short',
  Long = 'Long',
}
